import * as React from 'react'
import * as ImageConstants from './constants'

interface AIImageSettingsCellProps {
  dataItem: {
    options: string | object
  }
}

export const AIImageSettingsCell: React.FC<AIImageSettingsCellProps> = ({ dataItem }) => {
  let options: any = {}
  
  try {
    options = typeof dataItem.options === 'string' 
      ? JSON.parse(dataItem.options) 
      : (dataItem.options || {})
  } catch (e) {
    options = {}
  }

  // Helper function to get display text for option value
  const getOptionDisplay = (constantsArray: any[], value: string, fallback: string = 'Unknown') => {
    const option = constantsArray.find(opt => opt.value === value)
    return option ? option.description : fallback
  }

  const settings = [
    {
      label: 'Style',
      value: getOptionDisplay(ImageConstants.ImageStyleOptions, options.style, 'Realistic Photography')
    },
    {
      label: 'Quality', 
      value: getOptionDisplay(ImageConstants.ImageQualityOptions, options.quality, 'Standard Quality')
    },
    {
      label: 'Subject',
      value: getOptionDisplay(ImageConstants.SubjectFocusOptions, options.subjectFocus, 'Business & Corporate')
    },
    {
      label: 'Colors',
      value: getOptionDisplay(ImageConstants.ColorSchemeOptions, options.colorScheme, 'Natural Colors')
    },
    {
      label: 'Mood',
      value: getOptionDisplay(ImageConstants.MoodOptions, options.mood, 'Professional')
    },
    {
      label: 'Detail',
      value: getOptionDisplay(ImageConstants.ComplexityOptions, options.complexity, 'Moderate Detail')
    },
    {
      label: 'Art Style',
      value: getOptionDisplay(ImageConstants.ArtStyleOptions, options.artStyle, 'Modern')
    },
    {
      label: 'Lighting',
      value: getOptionDisplay(ImageConstants.LightingOptions, options.lighting, 'Natural Light')
    }
  ]

  return (
    <td>
      <div className="ai-image-settings-cell">
        {settings.map((setting, index) => (
          <div key={index} className="ai-image-setting-item">
            <span className="ai-image-setting-label">{setting.label}:</span>
            <span className="ai-image-setting-value">{setting.value}</span>
            {index < settings.length - 1 && <span className="ai-image-setting-separator"> • </span>}
          </div>
        ))}
      </div>
    </td>
  )
}